import type { Signal } from "@suse-o11y/signal";
import { createContext } from "react";

import { useRequiredContext } from "~/tools/use-required-context";

const ToggleListRootContext = createContext<null | Signal<string>>(null);

export const ToggleListRootContextProvider = ToggleListRootContext.Provider;

export const useToggleListNamespace = (): Signal<string> =>
	useRequiredContext(ToggleListRootContext, {
		providerName: "ToggleList.Root",
	});
